import { useEffect, useState } from 'react';
import axios from 'axios';
import { CONFIG } from 'variables/config';
import Card from 'components/card';
import { useNavigate, useParams } from 'react-router-dom';
import {
    MdDoneOutline,
    MdOutlinePayment,
    MdOutlineRocketLaunch,
} from 'react-icons/md';
import { getImage } from 'variables/images';

const Manager = () => {
    const [user, setUser] = useState<any>(null);
    const [leads, setLeads] = useState([]);
    const [offer, setOffer] = useState<any>({});
    const nav = useNavigate();
    const params = useParams();

    const initUser = () => {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('token'),
            },
        };
        axios
            .get(`${CONFIG.apiUrl}/user/me`, config)
            .then((res) => {
                setUser(res.data);
                if (res.data && res.data.isAdmin !== true) {
                    nav('/auth/sign-in');
                }
            })
            .catch((err) => {
                console.log('No user info found', err);
            });
    };

    const getOffer = (id: string) => {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('token'),
            },
        };
        axios
            .get(`${CONFIG.apiUrl}/offer/${id}`, config)
            .then((res) => {
                setOffer(res.data);
                console.log(res.data);
            })
            .catch((err) => {
                console.log('No user info found', err);
                //window.location.href = '/auth/sign-in';
            });
    };


    useEffect(() => {
        if (
            !localStorage.getItem('token') ||
            localStorage.getItem('token').length < 10
        )
            window.location.href = '/auth/sign-up';
        getOffer(params.id);
        initUser();
        // eslint-disable-next-line
    }, []);

    const InfoBox = (props: {
        icon?: any;
        title?: string;
        description?: string;
    }) => {
        const { icon, title, description } = props;
        return (
            <div className="w-full rounded-[20px] bg-lightPrimary p-6 dark:!bg-navy-700">
                <div className="grid grid-cols-12 gap-0">
                    <div className="col-span-1 text-gray-900">{icon}</div>
                    <h4 className="col-span-10 text-lg font-bold text-gray-900 dark:text-white">
                        {title}
                    </h4>
                </div>
                <p className="mt-[12px] pr-2 text-sm text-gray-700 dark:text-white">
                    {description}
                </p>
            </div>
        );
    };

    const deleteLead = (leadId: string) => {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('token'),
            },
        };

        axios
            .delete(`${CONFIG.apiUrl}/lead/${leadId}/${offer?._id}`, config)
            .then((res) => {
                console.log('Lead deleted');
                initMyLeads();
                getOffer(offer?._id);
            })
            .catch((err) => {
                console.log('No user info found', err);
            });
    };

    const initMyLeads = () => {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('token'),
            },
        };
        axios
            .get(
                `${CONFIG.apiUrl}/lead?orderNumber=${offer.offerNumber}`,
                config
            )
            .then((res) => {
                setLeads(res.data);
            })
            .catch((err) => {
                console.log('No user info found', err);
                window.location.href = '/auth/sign-in';
            });
    };

    useEffect(() => {
        if (
            !localStorage.getItem('token') ||
            localStorage.getItem('token').length < 10
        ) {
            window.location.href = '/auth/sign-up';
        }
        initUser();
    }, []);

    useEffect(() => {
        if (!offer?._id) return;
        initMyLeads();
    }, [offer]);

    function timeAgo(date: any) {
        const now: any = new Date();
        const givenDate: any = new Date(date);
        const diffInSeconds = Math.floor((now - givenDate) / 1000);

        const days = Math.floor(diffInSeconds / (3600 * 24));
        const hours = Math.floor((diffInSeconds % (3600 * 24)) / 3600);
        const minutes = Math.floor((diffInSeconds % 3600) / 60);
        const seconds = diffInSeconds % 60;

        if (days > 0) return `Il y a ${days} jour${days > 1 ? 's' : ''}`;
        if (hours > 0) return `Il y a ${hours} heure${hours > 1 ? 's' : ''}`;
        if (minutes > 0)
            return `Il y a ${minutes} minute${minutes > 1 ? 's' : ''}`;
        return `Il y a ${seconds} seconde${seconds > 1 ? 's' : ''}`;
    }

    function isWithin30Minutes(date: any) {
        const start = new Date();
        const end = new Date(date);
        const diffInMs = Math.abs(end.getTime() - start.getTime());
        const diffInMinutes = diffInMs / (1000 * 60);
        return diffInMinutes <= 30;
    }

    const deleteOffer = (id: string) => {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('token'),
            },
        };
        axios
            .delete(`${CONFIG.apiUrl}/seller-offer/${id}`, config)
            .then((res) => {
                console.log('Offer deleted');
                window.location.href = '/';
            })
            .catch((err) => {
                console.log('No user info found', err);
            });
    };

    return (
        <>
            <div className="mt-3 h-full w-full gap-2 rounded-[20px]">
                <Card
                    extra={
                        'relative w-full pb-[10px] pt-[10px] px-[29px] h-fit shadow shadow-3xl rounded-[20px] border'
                    }
                >
                    {/* Header */}
                    <div className="mt-1 flex gap-5">
                        <div className="hidden lg:block">
                            {getImage(offer?.industry, offer?.subIndustry) ? (
                                <img
                                    src={getImage(
                                        offer?.industry,
                                        offer?.subIndustry
                                    )}
                                    className="mb-1 max-h-[300px] w-full rounded-xl"
                                    alt={`${offer?.industry} ${offer?.subIndustry}`}
                                />
                            ) : (
                                <div className="flex h-[300px] w-[500px] items-center justify-center rounded-xl bg-gray-500">
                                    <p>
                                        {offer?.industry} - {offer?.subIndustry}
                                    </p>
                                </div>
                            )}
                        </div>
                        <div className="">
                            <p className="mt-5 max-w-[370px] text-xl text-navy-700 dark:text-white">
                                {offer?.subIndustry}
                            </p>
                            <h1 className="mt-2 text-2xl font-bold">
                                {offer?.industry}
                            </h1>
                            <p className="mb-5 text-sm font-bold">
                                #{offer?.offerNumber}
                            </p>
                            <div className="mb-5 mt-5 h-px w-full bg-gray-500"></div>
                            {offer?.status === 'done' && (
                                <InfoBox
                                    icon={<MdDoneOutline size={30} />}
                                    title={'Mission terminée'}
                                    description={`Vous avez généré ${
                                        offer?.leadsGenerated
                                    } leads (${
                                        offer?.leadsGenerated *
                                        offer?.sellerPrice.toFixed(2)
                                    }€ ) . Profitez de cette traction et cherchez un autre acheteur avec le même besoin`}
                                />
                            )}
                            {offer?.status === 'running' && (
                                <InfoBox
                                    icon={<MdOutlineRocketLaunch size={30} />}
                                    title={`Mission avec ${offer?.leadsGenerated}/${offer.weeklyQuantity} leads générés`}
                                    description={``}
                                />
                            )}
                            {offer?.status === 'waiting_payment' && (
                                <InfoBox
                                    icon={<MdOutlinePayment size={30} />}
                                    title={'En attente de paiement'}
                                    description={`Vous pourrez commencer votre campagne une fois la commande payée par
                                        l'acheteur. En attendant, si un lead est généré, nous nous assurons de
                                        vous le rediriger par mail.`}
                                />
                            )}
                            {!user?.isKYCVerified && (
                                <InfoBox
                                    icon={<MdOutlinePayment size={30} />}
                                    title={'Coordonées bancaires manquantes'}
                                    description={`Avant de vous positionner sur une offre, vous devez renseigner vos coordonées bancaires pour recevoir vos paiements.`}
                                />
                            )}
                            {!user?.isValidated && (
                                <p className="text-red-400">
                                    Nous sommes en train de vérifier votre
                                    compte. Vous ne pouvez pas encore postuler à
                                    une offre.
                                </p>
                            )}
                            {offer?.status === 'on_market' &&
                                user?.isKYCVerified &&
                                user?.isValidated && (
                                    <div className="rounded-2xl bg-lightPrimary px-3 py-3 ">
                                        <p className="ml-2 text-sm font-medium">
                                            Votre offre est disponible sur la
                                            marketplace pour{' '}
                                            {offer?.sellerPrice}€ par lead.
                                        </p>
                                    </div>
                                )}
                            <div className="mt-5 flex w-full gap-10">
                                <div className="mb-1 items-center gap-5">
                                    <p className="mb-1 text-sm font-bold">
                                        Quantité
                                    </p>
                                    <p className="mb-2 text-sm">
                                        {offer?.weeklyQuantity} leads
                                    </p>
                                </div>
                                <div className="mb-1 items-center gap-5">
                                    <p className="mb-1 text-sm font-bold">
                                        Canaux d'acquisition
                                    </p>
                                    <p className="mb-2 text-sm">
                                        {offer?.channels?.join(', ')}
                                    </p>
                                </div>
                                <div className="mb-1 items-center gap-5">
                                    <p className="mb-1 text-sm font-bold">
                                        Besoin
                                    </p>
                                    <p className="mb-2 text-sm">
                                        {offer?.type}
                                    </p>
                                </div>
                                <div className="mb-1 items-center gap-5">
                                    <p className="mb-1 text-sm font-bold">
                                        Site web
                                    </p>
                                    <p className="mb-2 text-sm">
                                        {offer?.websiteInfo}
                                    </p>
                                </div>
                                <p className="mb-1 text-sm font-bold">
                                    Champs de données
                                </p>
                                <p className="mb-2 text-sm">
                                    {offer?.fields?.join(', ')}
                                </p>
                                <div className="mb-1 items-center gap-5">
                                    <p className="mb-1 text-sm font-bold">
                                        Description
                                    </p>
                                    <p className="mb-2 text-sm">
                                        {offer?.description}
                                    </p>
                                </div>
                                <div className="mb-1 items-center gap-5">
                                    <p className="mb-2 text-sm font-bold">
                                        {' '}
                                        Départements:{' '}
                                    </p>
                                    <p className="mb-2 text-sm">
                                        {offer?.regions?.join(', ')}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    {leads.length === 0 ? (
                        <div className="mt-3">
                            <p className="text-center text-lg text-gray-500">
                                Aucun lead trouvé
                            </p>
                        </div>
                    ) : (
                        <table className="mt-3 w-full text-left text-sm text-gray-500 rtl:text-right">
                            <thead className="bg-gray-50 text-gray-700">
                                <tr>
                                    <th className="px-2 py-3"># ID Mission</th>
                                    <th className="px-2 py-3">Informations</th>
                                    <th className="px-2 py-3">Avancement</th>
                                    {/* <th className="px-2 py-3">Méthode</th>
                            <th className="px-2 py-3">Adresse email</th> */}
                                    <th className="px-2 py-3">Note leadrs</th>
                                    <th className="px-2 py-3">Note acheteur</th>
                                    <th className="px-2 py-3">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {leads.map((item, index) => (
                                    <tr
                                        key={index}
                                        className="border-b border-gray-200 bg-white text-gray-800 hover:bg-gray-100"
                                    >
                                        <td className="px-2 py-3">
                                            <p className="my-auto flex">
                                                #{item.orderNumber}
                                            </p>
                                            <div className="flex gap-2">
                                                {isWithin30Minutes(
                                                    item?.createdAt
                                                ) && (
                                                    <span className="relative my-auto flex h-2 w-2">
                                                        <span className="bg-toola-500/50 absolute inline-flex h-full w-full animate-ping rounded-full opacity-75"></span>
                                                        <span className="bg-toola-500/50 relative inline-flex h-2 w-2 rounded-full"></span>
                                                    </span>
                                                )}
                                                <p className="text-xs text-gray-700">
                                                    {timeAgo(item.createdAt)}
                                                </p>
                                            </div>
                                        </td>
                                        <td className="max-w-[300px] px-2 py-3 text-sm text-gray-700">
                                            <div className="line-clamp-2 overflow-hidden break-words">
                                                {item.body &&
                                                item.body.length > 0
                                                    ? item.body.map(
                                                          (
                                                              entry: any,
                                                              idx: number
                                                          ) => (
                                                              <span key={idx}>
                                                                  <strong>
                                                                      {
                                                                          entry.field
                                                                      }
                                                                      :
                                                                  </strong>{' '}
                                                                  {entry.answer}
                                                                  {idx <
                                                                      item.body
                                                                          .length -
                                                                          1 &&
                                                                      ', '}
                                                              </span>
                                                          )
                                                      )
                                                    : 'N/A'}
                                            </div>
                                        </td>
                                        <td className="px-2 py-3">
                                            {item.totalLeads > 1
                                                ? `${item.index}/${item.totalLeads}`
                                                : 'N/A'}
                                        </td>
                                        {/* <td className="px-2 py-3">
                                    {item.source || 'N/A'}
                                </td>
                                <td className="px-2 py-3">
                                    {item.email || 'N/A'}
                                </td> */}
                                        <td className="px-2 py-3">
                                            {item.leadrsRate === 0 && (
                                                <span className="rounded-full bg-red-200 px-2 py-1 text-xs text-red-700">
                                                    {item.leadrsRate}/10
                                                </span>
                                            )}
                                            {item.leadrsRate >= 7 && (
                                                <span className="rounded-full bg-green-200 px-2 py-1 text-xs text-green-700">
                                                    {item.leadrsRate}/10
                                                </span>
                                            )}
                                            {item.leadrsRate < 7 &&
                                                item.leadrsRate > 0 && (
                                                    <span className="rounded-full bg-yellow-200 px-2 py-1 text-xs text-yellow-700">
                                                        {item.leadrsRate}/10
                                                    </span>
                                                )}
                                        </td>
                                        <td className="px-2 py-3">
                                            {item.customerRate === -1 && 'N/A'}
                                            {item.customerRate === 0 && (
                                                <span className="rounded-full bg-red-200 px-2 py-1 text-xs text-red-700">
                                                    {item.customerRate}/5
                                                </span>
                                            )}
                                            {item.customerRate >= 4 && (
                                                <span className="rounded-full bg-green-200 px-2 py-1 text-xs text-green-700">
                                                    {item.customerRate}/5
                                                </span>
                                            )}
                                            {item.customerRate < 4 &&
                                                item.customerRate > 0 && (
                                                    <span className="rounded-full bg-yellow-200 px-2 py-1 text-xs text-yellow-700">
                                                        {item.customerRate}/5
                                                    </span>
                                                )}
                                        </td>
                                        <td className="max-w-[180px] px-2 py-3 text-xs">
                                            {/* Cancel lead button */}
                                            <button
                                                onClick={() =>
                                                    deleteLead(item._id)
                                                }
                                                className="flex items-center gap-1 rounded-xl bg-red-500 px-4 py-1 text-white hover:bg-red-600"
                                            >
                                                Supprimer le lead
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </Card>
            </div>
        </>
    );
};

export default Manager;
